/**
 * Axe-core accessibility testing configuration
 *
 * This module initializes axe-core for automated accessibility testing
 * in development mode. Violations are logged to the console with detailed
 * information about WCAG criterion failures.
 *
 * IMPORTANT: Only runs in development mode to avoid performance impact in production.
 */

let initialized = false;

export async function initializeAxe() {
  // Only run in development mode
  if (import.meta.env.MODE !== 'development' || initialized) {
    return;
  }

  try {
    const React = await import('react');
    const ReactDOM = await import('react-dom');
    const axe = await import('@axe-core/react');

    // Configure axe-core with custom rules
    await axe.default(React, ReactDOM, 1000, {
      // Rules configuration
      rules: [
        // Enforce WCAG 2.2 Level AA
        { id: 'color-contrast', enabled: true },
        { id: 'html-has-lang', enabled: true },
        { id: 'label', enabled: true },
        { id: 'link-name', enabled: true },
        { id: 'button-name', enabled: true },
      ],
    });

    // Use console.warn for styled development logging (axe-core integration)
    // eslint-disable-next-line no-console -- Axe-core accessibility testing requires console
    console.warn(
      '%c♿ Axe-core initialized',
      'background: #3b82f6; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold',
      '\nAccessibility testing active. Violations will be logged to console.',
    );

    initialized = true;
  } catch (error) {
    // eslint-disable-next-line no-console -- Axe-core initialization error needs console
    console.error('Failed to initialize axe-core:', error);
  }
}
